import React, { useCallback, useEffect, useRef, useState } from 'react'
import { ColumnsTable } from 'safe'
import Table from '../../components/Display/Table'
import InventoryForm, { IInvetoryForm } from './InventoryForm'
import Modal from '../../components/Display/Modal'

import defaultImage from '../../assets/images/img-placeholder.jpg'
import ItemAnimation from '../../assets/animations/item_animation.json'
import { AnimatePresence, motion } from 'framer-motion'
import Empty from '../../components/Display/Empty'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { HiAdjustments, HiDotsVertical, HiOutlinePencil } from 'react-icons/hi'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import Button from '../../components/General/Button'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import ModalConfirm from '../../components/Display/ModalConfirm'
import { FiTrash2 } from 'react-icons/fi'
import FieldArrayAutocomplete from '../../components/Inputs/FieldArrayAutocomplete'
import CostForm from './CostForm'
import EditCompoundForm from './EditCompoundForm'
import EmptyBox from '../../assets/animations/empty_box.json'
import RotationForm from './RotationForm'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import {
  transformDate,
  formatAmount,
  getItemType,
  getDenomination,
  formatPipe,
} from '../../utils/utils'
import { tax } from '../../userConfig'
import ModalInventorySearch from '../../components/Display/ModalInventorySearch'
import { InventorySearch } from 'safe'
import AssociatedCode, { IAssociatedCodes } from './AssociatedCode'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import {
  createItem,
  fetchItems,
  ICreateITemDTO,
  IItem,
  IITemsResponse,
  IUpdateItemDTO,
  removeItem,
  updateItem,
} from '../../common/Inventory/Items'
import { setCatalogStatus } from '../../common/Inventory/Catalog'
import { fetchUnits, IUnit } from '../../common/Inventory/Units'
import { deleteAssociatedCode } from '../../common/Inventory/AssociatedCode'
import {
  createComposition,
  removeComposition,
  updateComposition,
} from '../../common/Inventory/Compound'
import {
  createAssembly,
  removeAssembly,
  updateAssembly,
} from '../../common/Inventory/Assembly'
import { IBatch } from '../../common/Inventory/Rotation'
import { HeaderProps } from '../../components/Layout/Header'
import FloatingForm from '../../components/Display/FloatingForm'
import PriceAdjustForm from './PriceAdjustForm'
import axios from 'axios'
import { IoMdCreate } from 'react-icons/io'
import InventorySearchFormFloating from './InventorySearchFormFloating'
import AdvancedInventoryForm from '../../components/Display/AdvancedInventoryForm'
import { deleteToS3 } from '../../utils/UploadFile'
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material'

const server = process.env.REACT_APP_SERVER_URL
const bucket = process.env.REACT_APP_S3_URL

const Inventory: React.FC<InventoryProps> = ({ setHeaderActions }) => {
  const [itemState, setItemState] = useState<IITemsResponse>({
    items: [],
    status: 0,
    numberOfPages: 0,
  })
  const { items, numberOfPages } = itemState
  const [units, setUnits] = useState<IUnit[]>([])
  const [modal, setModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [edit, setEdit] = useState<IItem | null>(null)
  const { addAlert } = useSnackBars()
  const [categoriesValues, setCategoriesValues] = useState<any[]>([])
  const [modalSearch, setModalSearch] = useState<boolean>(false)
  const [menuVisible, setMenuVisible] = useState<any>()
  const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
  const [visibleCode, setVisibleCode] = useState<boolean>(false)
  const [visiblePrice, setVisiblePrice] = useState<boolean>(false)
  const [modalFromRow, setModalFromRow] = useState<boolean>(false)
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])

  const [
    showConfirmCategoryModal,
    setShowConfirmCategoryModal,
  ] = useState<boolean>(false)

  const [monitorModal, setMonitorModal] = useState<boolean>(false)
  const [confirmModalAssociated, setConfirmModalAssociated] = useState<boolean>(
    false
  )
  const [confirmModalCompound, setConfirmModalCompound] = useState<boolean>(
    false
  )
  const [confirmModalAssembly, setConfirmModalAssembly] = useState<boolean>(
    false
  )
  const [valueToDelete, setValueToDelete] = useState<string>('')
  const [itemToDelete, setItemToDelete] = useState<any>(null)
  const [valueCompoundToDelete, setValueCompoundToDelete] = useState<
    string | null
  >(null)
  const [valueAssemblyToDelete, setValueAssemblyToDelete] = useState<string>('')
  const [visibleCompound, setVisibleCompound] = useState<boolean>(false)
  const [visibleCompositionEdit, setVisibleCompositionEdit] = useState<boolean>(
    false
  )
  const [visibleAssemblyEdit, setVisibleAssemblyEdit] = useState<boolean>(false)
  const [selectedCompoundToEdit, setSelectedCompoundToEdit] = useState<
    any | null
  >(null)
  const [selectedAssemblyToEdit, setSelectedAssemblyToEdit] = useState<
    any | null
  >(null)
  const [visibleAssembly, setVisibleAssembly] = useState<boolean>(false)
  const [visibleAdjust, setVisibleAdjust] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useState<string[]>([])
  const [fastSearch, setFastSearch] = useState<string>('')
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [currentEvaluate, setCurrentEvaluate] = useState<string>('none')
  const [arrayOfCodes, setArrayOfCodes] = useState<
    IAssociatedCodes | undefined
  >()
  const [compositions, setCompositions] = useState<any[]>([])

  const [urlSelectedItem, setUrlSelectedItem] = useState<string>('')

  const [userConfig] = useLocalStorageState('user-config')

  const categories = useSelector((state: RootState) => state.ctgr.categories)
  const userTenantId = useSelector(
    (state: RootState) => state.auth.user['custom:tenant_id']
  )

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const compoundForm = useForm()

  const refDivScrollCompound = useRef<HTMLDivElement | null>(null)
  const refDivScrollAssociated = useRef<HTMLDivElement | null>(null)

  const [rawMaterials, setRawMaterials] = useState<any[]>([])

  // const [docs, setDocs] = useState<{ value: string; text: string }[]>([
  //   {
  //     value: 'code',
  //     text: 'Código',
  //   },
  //   {
  //     value: 'keywords',
  //     text: 'Palabras Claves',
  //   },
  //   {
  //     value: 'category',
  //     text: 'Categoria',
  //   },
  // ])

  // const objTransform = {
  //   ASSEMBLY: {
  //     value: 'Ensamblado',
  //     style: 'text-primaryOrange'
  //   },
  //   NORMAL: {
  //     value: 'Normal',
  //     style: 'text-primary'
  //   },
  //   COMPOUND: {
  //     value: 'Compuesto',
  //     style: 'text-primaryGreen'
  //   },
  //   PRODUCTION: {
  //     value: 'Producción',
  //     style: 'text-warning'
  //   }
  // }

  // useEffect(() => {
  //   console.log("cambiaron los valores", items[items.findIndex(v => v?.id === edit?.id)]?.composition)
  // }, [items[items.findIndex(v => v.id === edit?.id)]?.composition])

  // const fetchAndSetItems = useCallback(
  //   async (
  //     querySearch: string[] = searchParams,
  //     paginationParams: string[] = [
  //       `pageNumber=${currentPage + 1}`,
  //       `pageSize=${userConfig.rowsPerPage}`,
  //     ],
  //     evaluate = currentEvaluate
  //   ) => {
  //     console.log('search params', searchParams)
  //     const response = await fetchItems(querySearch, paginationParams, evaluate)
  //     if (modalSearch) {
  //       setModalSearch(false)
  //     }
  //     setItemState(response)
  //   },
  //   [searchParams, currentPage, userConfig.rowsPerPage, currentEvaluate]
  // )

  const fetchAndSetItems = async (
    params: string[] = searchParams,
    pageNumber: number = 0,
    fastParam = fastSearch
  ) => {
    const paginationParams = [
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    setFastSearch(fastParam)

    setCurrentPage(pageNumber)

    setSearchParams(params)

    setLoading(true)

    let newParams = [...params]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }

    const response = await fetchItems(newParams, paginationParams, '')
    setLoading(false)
    setItemState(response)
  }

  const fetchAndSetUnits = useCallback(async () => {
    const units = await fetchUnits()
    setUnits(units)
  }, [])

  useEffect(() => {
    fetchAndSetUnits()
  }, [fetchAndSetUnits])

  useEffect(() => {
    // setLoading(true)
    fetchAndSetItems()
    // setLoading(false)
    // console.log("llega...")
    // fetchItems(searchParams, [
    //   `pageNumber=${currentPage + 1}`,
    //   `pageSize=${userConfig.rowsPerPage}`,
    // ], currentEvaluate)
    // // fetchItems()
  }, [])

  let objTransform = {
    GENERAL: 'GENERAL',
    REDUCED: 'REDUCIDO',
    EXEMPT: 'EXENTO',
    SUMPTUARY: 'SUNTUARIO',
  }

  const setNewRotation = async (idItem: string, batch: any) => {
    // const itemsCopy = [...items]
    // const item = itemsCopy.find((item) => item.id === idItem)
    // if (item) {
    //   item.batch.push(batch)
    //   setItemState((prev) => ({ ...prev, items: itemsCopy }))
    // }
    // console.log("new rotation....", idItem)
    // console.log("new batch", batch)
    try {
      addAlert({
        message: 'Ingresando lote',
        status: 'loading',
      })
      await axios.post(`${server}/inventory/batch`, {
        ...batch,
        item: {
          id: idItem,
        },
      })
      setMonitorModal(false)
      addAlert({
        message: 'Lote ingresado satisfactoriamente.',
        status: 'success',
      })
    } catch (err) {
      addAlert({
        message: 'Error al ingresar lote.',
        status: 'error',
      })
    }
  }

  const onInventorySubmitFilter = async (
    values: InventorySearch
  ): Promise<void> => {
    if (values.typeSelected === 'code') {
      setCurrentEvaluate('code')
      setSearchParams([`code=${values.code}`])
      if (currentPage === 0) {
        setLoading(true)
        await fetchAndSetItems([`code=${values.code}`], currentPage + 1)
        setLoading(false)
      } else {
        setCurrentPage(0)
      }
    }

    if (values.typeSelected === 'keywords') {
      setCurrentEvaluate('name')
      setSearchParams([`name=${values.name}`])
      if (currentPage === 0) {
        setLoading(true)
        await fetchAndSetItems([`name=${values.name}`], currentPage + 1)
        setLoading(false)
      } else {
        setCurrentPage(0)
      }
    }

    if (values.typeSelected === 'category') {
      if (currentPage === 0) {
        if (values.subCategory !== '0') {
          setCurrentEvaluate('subcategory')
          setLoading(true)
          await fetchAndSetItems(
            [`idSubCategory=${values.subCategory}`],
            currentPage + 1
          )
          setLoading(false)
          setSearchParams([`idSubCategory=${values.subCategory}`])
        } else {
          setCurrentEvaluate('category')
          setLoading(true)
          await fetchAndSetItems(
            [`idCategory=${values.category}`],
            currentPage + 1
          )
          setLoading(false)
          setSearchParams([`idCategory=${values.category}`])
        }
      } else {
        if (values.subCategory !== '0') {
          setCurrentEvaluate('subcategory')
          setSearchParams([`idSubCategory=${values.subCategory}`])
          setCurrentPage(0)
        } else {
          setCurrentEvaluate('category')
          setSearchParams([`idCategory=${values.category}`])
          setCurrentPage(0)
        }
      }
    }
    setModalSearch(false)
  }

  const pressRow = async (value: IItem) => {
    let response = await axios.get(`${server}/inventory/item?id=${value.id}`)

    const { item } = response.data

    const itemDetails = { title: '', data: '' }
    const priceDetails = { title: '', data: '' }
    const batchDetails = { title: '', data: '' }
    const compositionDetails = { title: '', data: '' }
    const assemblyDetails = { title: '', data: '' }
    const codeDetails = { title: '', data: '' }
    const existenceDetails = { title: '', data: '' }

    itemDetails.title = 'Artículo'
    itemDetails.data += `Nombre: ${item.name}\n`
    itemDetails.data += `Descripción: ${item.description}\n`
    itemDetails.data += `Marca: ${item.brand}\n`
    item.barcode && (itemDetails.data += `Código de barras: ${item.barcode}\n`)
    item.sku && (itemDetails.data += `SKU: ${item.sku}\n`)
    // itemDetails.data += `Exento: ${item.exempt ? 'Sí' : 'No'}\n`
    // itemDetails.data += `Compuesto: ${item.type === 'COMPOUND' ? 'Sí' : 'No'}\n`
    itemDetails.data += `Categoría: ${item.category.name}\n`
    // itemDetails.data += `Subcategoría: ${
    //   item.subcategory ? item.subcategory.name : 'Sin subcategoría'
    // }\n`
    // itemDetails.data += `Unidad de Medida: ${item.unit.name}\n`
    // itemDetails.data += `Abreviatura de Unidad: ${item.unit.abbreviatedName}\n`

    const dataToShow = [itemDetails]

    // if (item.locationAndQuantity) {
    //   existenceDetails.title += 'Existencia'
    //   for (const existence of item.locationAndQuantity) {
    //     existenceDetails.data += `\tAlmacén: ${existence.name}\n`
    //     existenceDetails.data += `\tCantidad: ${existence.quantity} ${item.unit.abbreviatedName}\n\n`
    //   }
    //   dataToShow.push(existenceDetails)
    // }

    // if (item.cost.length > 0 && item.price.length > 0) {
    priceDetails.title = 'Costos y Precios'
    priceDetails.data += `Precio:\t Bs ${item.price || '0'}\n`
    priceDetails.data += `Costo:\t Bs ${item.cost || '0'}\n`
    priceDetails.data += `Ganancia:\t   ${Math.round(
      (Number(item.price) / Number(item?.cost) - 1) * 100
    )}%\n`
    priceDetails.data += `Impuesto:\t   ${
      item.exempt ? 'excento' : tax + '%'
    }\n`
    !item.exempt &&
      (priceDetails.data += `Precio antes de Impuesto:\t Bs ${Number(
        (Number(item.price) / (1 + Number(tax) / 100)).toFixed(2)
      )}`)
    dataToShow.push(priceDetails)
    // }

    // if (item.batch.length > 0) {
    //   batchDetails.title = 'Rotación'
    //   item.batch.length > 0 &&
    //     (batchDetails.data += `Fecha de creación: ${transformDate(
    //       item.batch[0].creation_date
    //     )}\n`)
    //   item.batch.length > 0 &&
    //     (batchDetails.data += `Fecha de expiración: ${transformDate(
    //       item.batch[0].expiration_date
    //     )}\n`)
    //   item.batch.length > 0 &&
    //     (batchDetails.data += `Lote: ${item.batch[0].batch}\n`)
    //   item.batch.length > 0 &&
    //     (batchDetails.data += `Fecha de rotación: ${transformDate(
    //       item.batch[0].rotation_date
    //     )}\n`)
    //   dataToShow.push(batchDetails)
    // }

    // if (item.associatedCode.length > 0) {
    //   codeDetails.title = 'Códigos'
    //   item.barcode &&
    //     (codeDetails.data += `Código de barras: ${item.barcode}\n`)
    //   item.sku && (codeDetails.data += `SKU: ${item.sku}\n`)
    //   codeDetails.data += `Códigos asociados:\n`
    //   for (const code of item.associatedCode) {
    //     codeDetails.data += `  - ${code.code}\n`
    //   }
    //   dataToShow.push(codeDetails)
    // }

    // if (item.composition.length > 0) {
    //   compositionDetails.title = 'Composición'
    //   for (let i = 0; i < item.composition.length; i++) {
    //     compositionDetails.data += `  ${i + 1}) Nombre: ${item.composition[i].item.name
    //       }\n`
    //     compositionDetails.data += `     Cantidad: ${formatAmount(
    //       item.composition[i].amount,
    //       item.composition[i].item.unit
    //     )}\n\n`
    //   }
    //   dataToShow.push(compositionDetails)
    // }

    // if (item.assembly.length > 0) {
    //   assemblyDetails.title = 'Ensamblado'
    //   for (let i = 0; i < item.assembly.length; i++) {
    //     assemblyDetails.data += `  ${i + 1}) Nombre: ${item.assembly[i].productionItem.name
    //       }\n`
    //     assemblyDetails.data += `     Cantidad: ${formatAmount(
    //       item.assembly[i].productionItem.requiredQuantity,
    //       item.assembly[i].productionItem.unit
    //     )}\n\n`
    //   }
    //   dataToShow.push(assemblyDetails)
    // }

    // dataToShow.push(priceDetails)
    // item.batch.length > 0 && (dataToShow.push(batchDetails))
    // item.associatedCode.length > 0 && (dataToShow.push(codeDetails))
    // item.composition.length > 0 && (dataToShow.push(compositionDetails))
    setDataWithTabs(dataToShow)
    setModalFromRow(true)
  }

  const adjustPricesGlobally = async (percentage: number) => {
    const operator = percentage < 0 ? 'negative' : 'positive'
    const body = {
      percentage: Math.abs(percentage),
      operator,
    }
    try {
      setLoading(true)
      addAlert({ message: 'Actualizando Precios...', status: 'loading' })
      await axios.post(`${server}/inventory/item/price/percentage`, body)
      addAlert({ message: 'Precios Actualizados!', status: 'success' })
      setVisibleAdjust(false)
      await fetchAndSetItems([], 0)
      setLoading(false)
    } catch (error: any) {
      addAlert({
        message:
          error?.response?.data?.message || 'Error al actualizar precios',
        status: 'error',
      })
      setLoading(false)
    }
  }

  const onSubmit = async (values: IInvetoryForm): Promise<void> => {
    // const profit = +(values.profit / 100).toFixed(2)
    // const tax = +(values.tax / 100).toFixed(2) || 0
    // const price = +(values.cost * profit).toFixed(2)
    // const category = { id: +values.category }
    if (values?.category?.id === '') {
      addAlert({
        message: 'Debe al menos especificar una categoría',
        status: 'error',
      })
      return
    }
    const fd = new FormData()
    try {
      if (values.barcode === '' && values.sku === '') {
        addAlert({
          message: 'Especifique al menos un código de barras o un SKU',
          status: 'error',
        })
        return
      }

      if (values.barcode === values.sku) {
        addAlert({
          message: 'El código de barras y el SKU deben ser distintos',
          status: 'error',
        })
        return
      }

      if (values.type === 'COMPOUND') {
        values.unit = '1'
        values.brand = ''
        values.barcode = null
      }

      values.barcode === '' && (values.barcode = null)
      values.sku === '' && (values.sku = null)

      setLoading(true)

      if (!values.id) {
        setLoading(true)

        addAlert({ message: 'Creando Articulo...', status: 'loading' })

        const {
          barcode,
          sku,
          brand,
          category,
          description,
          exempt: boolean,
          imageToDelete,
          name,
          subcategory,
          type,
          unit,
          price,
          cost,
          currency,
          ivaType,
        } = values

        const newItem: ICreateITemDTO = {
          barcode,
          sku,
          brand,
          category,
          cost,
          price,
          description,
          exempt: boolean,
          imageToDelete,
          name,
          subcategory,
          type,
          unit: {
            id: unit,
          },
          currency,
          ivaType,
        }

        if (values.image) {
          fd.append('media', values.image)
          fd.append('fileType', 'photo')
          // values.image.name = `${userTenantId}`
          await createItem(newItem, true, fd, values.image, userTenantId)
          delete values.image
        } else {
          await createItem(newItem, false, fd)
        }
        // setSearchParams([])
        // setCurrentPage(0)
        // if (currentPage === 0) {
        //   await fetchItems([], [
        //     `pageNumber=${1}`,
        //     `pageSize=${userConfig.rowsPerPage}`,
        //   ])
        // }
        addAlert({ message: 'Articulo creado!', status: 'success' })
      } else {
        addAlert({ message: 'Actualizando Articulo...', status: 'loading' })
        const {
          id,
          barcode,
          sku,
          brand,
          category,
          cost,
          price,
          description,
          exempt: boolean,
          imageToDelete,
          name,
          subcategory,
          type,
          unit,
          currency,
          ivaType,
        } = values

        const newItem: IUpdateItemDTO = {
          id,
          barcode,
          sku,
          brand,
          cost,
          price,
          category,
          description,
          exempt: boolean,
          imageToDelete,
          name,
          subcategory,
          type,
          unit: {
            id: unit,
          },
          currency,
          ivaType,
        }

        if (values.image) {
          // console.log('values image', values.image)
          fd.append('media', values.image)
          fd.append('fileType', 'photo')
          await updateItem(newItem, values.image, urlSelectedItem, userTenantId)
          delete values.image
        } else {
          await updateItem(newItem, '', urlSelectedItem)
        }
        addAlert({ message: 'Articulo actualizado!', status: 'success' })
      }
      // setSearchParams([])
      // setCurrentEvaluate('none')
      // if (currentPage === 0) {
      await fetchAndSetItems([], 0)
      setModal(false)
      setEdit(null)
      // } else {
      //   setCurrentPage(0)
      // }
      // setLoading(false)
    } catch (error: any) {
      console.log('ERROR', error)
      if (error?.response?.status === 400) {
        if (error?.response?.data?.message === 'Sku already exists') {
          addAlert({
            message: 'El sku ya existe',
            status: 'error',
          })
        } else if (error?.response?.data?.message === 'Barcode already exists') {
          addAlert({
            message: 'El código de barra ya existe',
            status: 'error',
          })
        }
      } else {
        addAlert({
          message: 'Error de servidor',
          status: 'error',
        })
      }
      setLoading(false)
    } finally {
      setUrlSelectedItem('')
      setLoading(false)
    }
  }

  const onDeleteItem = async (): Promise<void> => {
    try {
      addAlert({ message: 'Eliminando Articulo...', status: 'loading' })
      await removeItem(itemToDelete.id)
      if (itemToDelete.image) {
        await deleteToS3(itemToDelete.image)
      }
      addAlert({ message: 'Articulo Eliminado!', status: 'success' })
    } catch (error: any) {
      if (error?.response?.data?.message === 'The item has existence') {
        addAlert({
          message: 'No se puede eliminar el artículo ya que posee existencia',
          status: 'error',
        })
      } else {
        addAlert({
          message: 'Error al eliminar el articulo',
          status: 'error',
        })
      }
    } finally {
      setEdit(null)
      await fetchAndSetItems([], 0)
      setVisibleDelete(false)
      // setLoading(false)
    }
  }

  const onFilterCompund = (values, record: any): any => {
    // if (record.type === 'PRODUCTION') {
    //   const { onPrice, onCompound, onAssembly, ...rest } = values
    //   return rest
    // }
    if (record.type === 'FINISHED_PRODUCT') {
      return values
    }
    if (record.type === 'COMPOUND') {
      if (record.inCatalog) {
        const {
          onAssembly,
          onTracking,
          onAssociated,
          onSendToCatalog,
          onCost,
          addRawMaterial,
          ...val
        } = values
        return {
          ...val,
          onDeleteFromCatalog: async () => {
            try {
              await setCatalogStatus(record.id, false)
              addAlert({
                message: 'Artículo removido de catálogo',
                status: 'success',
              })
            } catch (err) {
              addAlert({ message: 'Error de servidor', status: 'error' })
            }
          },
        }
      } else {
        const {
          onAssembly,
          onTracking,
          onAssociated,
          onCost,
          addRawMaterial,
          ...val
        } = values
        return val
      }
    }
    if (record.type === 'ASSEMBLY') {
      if (record.inCatalog) {
        const {
          onCompound,
          onTracking,
          onAssociated,
          onSendToCatalog,
          onCost,
          addRawMaterial,
          ...val
        } = values
        return {
          ...val,
          onDeleteFromCatalog: async () => {
            try {
              await setCatalogStatus(record.id, false)
              addAlert({
                message: 'Artículo removido de catálogo',
                status: 'success',
              })
            } catch (err) {
              addAlert({ message: 'Error de servidor', status: 'error' })
            }
          },
        }
      } else {
        const { onCompound, onTracking, onAssociated, onCost, ...val } = values
        return val
      }
    }
    const { onCompound, addRawMaterial, ...rest } = values
    return rest
    // if (record.inCatalog) {
    //   const { onCompound, onAssembly, onSendToCatalog, onCost, ...val } = values
    //   return {
    //     ...val,
    //     onDeleteFromCatalog: async () => {
    //       try {
    //         await setCatalogStatus(record.id, false)
    //         addAlert({
    //           message: 'Artículo removido de catálogo',
    //           status: 'success',
    //         })
    //       } catch (err) {
    //         addAlert({ message: 'Error de servidor', status: 'error' })
    //       }
    //     },
    //   }
    // } else {
    //   const { onCompound, onAssembly, onCost, ...val } = values
    //   return val
    // }
    // if (!record.compound) {
    //   const { onCompound, ...val } = values
    //   return val
    // } else {
    //   const { onAssociated, onTracking, ...val } = values
    //   return val
    // }
  }

  const columns: ColumnsTable[] = [
    {
      title: ' ',
      dataIndex: 'images',
      key: 'images',
      width: 50,
      render: (images: any[], record: any) => (
        <div className="ml-2 h-9 w-9 rounded-lg border-white dark:border-gray-700 dark:bg-dark-less border-4 flex">
          <img
            className="object-cover rounded-md"
            src={
              record.image
                ? `${record.image}?${global.Date.now()}`
                : defaultImage
            }
            alt={`${record?.id}-img`}
          />
        </div>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Categoría',
      dataIndex: 'category.name',
      key: 'category.name',
    },
    {
      title: 'Marca',
      dataIndex: 'brand',
      key: 'brand',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
        // subElement="paragraph"
        // subElementStyle={'dark:text-white text-black'}
        >
          {record?.brand ? record?.brand : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
        // subElement="paragraph"
        // subElementStyle="dark:text-white text-black"
        >
          {record?.sku ? record?.sku : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    // {
    //   title: 'Código de barras',
    //   dataIndex: 'barcode',
    //   key: 'barcode',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper
    //       // subElement="paragraph"
    //       // subElementStyle="dark:text-white text-black"
    //     >
    //       {record?.barcode ? record?.barcode : 'N/A'}
    //     </ColumnItemWrapper>
    //   ),
    // },
    {
      title: 'Tipo de iva',
      dataIndex: 'ivaType',
      key: 'ivaType',
      render: (id: number, record: any) => {
        return (
          <ColumnItemWrapper>{objTransform[record.ivaType]}</ColumnItemWrapper>
        )
      },
    },
    {
      title: 'Precio',
      dataIndex: 'price',
      key: 'price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {`${getDenomination(record?.currency?.id)} ${formatPipe(
            record?.price
          )}`}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Existencia',
      dataIndex: 'totalQuantity',
      key: 'totalQuantity',
      align: 'center',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {/* <span className="dark:text-white text-black"> */}
          {record.totalQuantity || '0'}
          {/* </span> */}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Tipo',
      align: 'center',
      dataIndex: 'compound',
      key: 'type',
      width: 50,
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          <p className={`${getItemType(record.type).style}`}>
            {getItemType(record.type).value}
            {/* {record?.compound ? 'Compuesto' : 'Normal'} */}
          </p>
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => (
        <ColumnItemWrapper floatingMenu>
          {/* <div className="text-gray-500 relative"> */}
          <FloatingMenu
            visible={menuVisible === id}
            onClose={() => {
              setMenuVisible(-1)
            }}
            options={onFilterCompund(
              {
                onEdit: () => {
                  setUrlSelectedItem(record.image)
                  setModal(true)
                  setEdit(record)
                },
                // onAssembly: () => {
                //   setVisibleAssembly(true)
                //   // setVisibleCompound(true)
                //   setEdit(record)
                // },
                onDelete: () => {
                  setItemToDelete(record)
                  setVisibleDelete(true)
                },
                // onAssociated: async () => {
                //   let response = await axios.get(
                //     `${server}/inventory/code?item=${id}`
                //   )
                //   setArrayOfCodes(response.data)
                //   setVisibleCode(true)
                //   setEdit(record)
                // },
                // onTracking: () => {
                //   setMonitorModal(true)
                //   setEdit(record)
                // },
                // onCompound: async () => {
                //   let response = await axios.get(
                //     `${server}/inventory/composition?id=${id}`
                //   )
                //   setCompositions(response.data.items || [])
                //   setVisibleCompound(true)
                //   setEdit(record)
                // },
                addRawMaterial: async () => {
                  let resp = await axios.get(
                    `${server}/inventory/composition?id=${record?.id}`
                  )
                  setRawMaterials(resp?.data?.items || [])
                  setVisibleCompound(true)
                  setEdit(record)
                },
                // onPrice: () => {
                //   setVisiblePrice(true)
                //   setEdit(record)
                // },
                // onCost: () => {
                //   setVisiblePrice(true)
                //   setEdit(record)
                // },
                // onSendToCatalog: async () => {
                //   try {
                //     await setCatalogStatus(record.id, true)
                //     addAlert({
                //       message: 'Artículo transferido a catálogo',
                //       status: 'success',
                //     })
                //   } catch (err) {
                //     addAlert({ message: 'Error de servidor', status: 'error' })
                //   }
                // },
              },
              record
            )}
          >
            <HiDotsVertical
              className="cursor-pointer dark:text-white text-primaryGray-400"
              onClick={() => {
                setMenuVisible(id)
                // setEdit(record)
                // setModal(true)
              }}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  useEffect(() => {
    if (userRole === 'seniat') {
      setHeaderActions({
        // onCustomAction: [
        //   {
        //     title: 'A. Precios',
        //     icon: <HiAdjustments />,
        //     buttonType: 'outline',
        //     action: () => setVisibleAdjust(true),
        //     display: true,
        //     tooltipMessage: 'Ajustar Precios Masivamente',
        //   },
        // ],
        advancedSearch: async (value) => {
          if (typeof value === 'boolean') {
            setModalSearch(value)
            return
          }
          // setFastSearch(value)
          fetchAndSetItems(searchParams, 0, value)
          // setSearchParams([`fastSearch=${value}`])
          // if (currentPage === 0) {
          //   setLoading(true)
          //   await fetchAndSetItems(
          //     [],
          //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          //   )
          //   setLoading(false)
          // } else {
          //   setCurrentPage(0)
          // }
        },
        // searchAction: () => setModalSearch(true),
        cleanFilters: {
          sort: () => {},
          search: async () => {
            fetchAndSetItems([], 0)
            // setSearchParams([])
            // setCurrentEvaluate('none')
            // if (currentPage === 0) {
            //   setLoading(true)
            //   await fetchAndSetItems()
            //   setLoading(false)
            // }
            // setCurrentPage(0)
          },
          isSearch: Boolean(searchParams.length > 0),
        },
      })
    } else {
      setHeaderActions({
        // onCustomAction: [
        //   {
        //     title: 'A. Precios',
        //     icon: <HiAdjustments />,
        //     buttonType: 'outline',
        //     action: () => setVisibleAdjust(true),
        //     display: true,
        //     tooltipMessage: 'Ajustar Precios Masivamente',
        //   },
        // ],
        advancedSearch: async (value) => {
          if (typeof value === 'boolean') {
            setModalSearch(value)
            return
          }
          // setFastSearch(value)
          fetchAndSetItems(searchParams, 0, value)
          // setSearchParams([`fastSearch=${value}`])
          // if (currentPage === 0) {
          //   setLoading(true)
          //   await fetchAndSetItems(
          //     [],
          //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          //   )
          //   setLoading(false)
          // } else {
          //   setCurrentPage(0)
          // }
        },
        addAction: () => {
          if (categories.length === 0) {
            setShowConfirmCategoryModal(true)
            return
          }
          setModal(true)
        },
        // searchAction: () => setModalSearch(true),
        cleanFilters: {
          sort: () => {},
          search: async () => {
            fetchAndSetItems([], 0)
            // setSearchParams([])
            // setCurrentEvaluate('none')
            // if (currentPage === 0) {
            //   setLoading(true)
            //   await fetchAndSetItems()
            //   setLoading(false)
            // }
            // setCurrentPage(0)
          },
          isSearch: Boolean(searchParams.length > 0),
        },
      })
    }
    // fetchItems(searchParams, [
    //   `pageNumber=${currentPage + 1}`,
    //   `pageSize=${userConfig.rowsPerPage}`,
    // ])

    return () => setHeaderActions(null)
  }, [
    setHeaderActions,
    searchParams,
    currentPage,
    categories,
    fastSearch,
    userRole,
  ])

  useEffect(() => {
    // throw new Error("Error")
    setCategoriesValues(
      categories?.map((category) => ({
        value: category?.id,
        text: category?.name,
      }))
    )
  }, [categories])

  // useEffect(() => {
  //   if (categoriesValues.length === 0) {
  //     setDocs(prev => prev.filter((doc) => doc.value !== 'category'))
  //   } else {
  //     setDocs((prevState) => [
  //       ...prevState,
  //       {
  //         value: 'category',
  //         text: 'Categoria',
  //       },
  //     ])
  //   }
  // }, [categoriesValues])

  return (
    <>
      <ModalConfirm
        isInfo={true}
        displayConfirmModal={showConfirmCategoryModal}
        title="Debe poseer al menos una categoría registrada antes de agregar productos"
        onCancel={() => setShowConfirmCategoryModal(false)}
        onConfirm={() => setShowConfirmCategoryModal(false)}
        positive={true}
      />

      <div className="hidden md:block">
        <AnimatePresence>
          {items?.length <= 0 ? (
            <Empty
              animationProps={{
                animation: ItemAnimation,
                width: 360,
                height: 360,
              }}
            >
              <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                El inventario es imprescindible, inicia agregando productos a tu
                catalogo para comenzar a comprar y vender.
              </p>
            </Empty>
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <Table
                data={items}
                columns={userRole === "seniat" ? columns.slice(0, -1) : columns}
                pages={numberOfPages}
                pageSelected={currentPage}
                loading={loading}
                // onPressButton={pressRow}
                setPageSelected={(page) => fetchAndSetItems(searchParams, page)}
                setLoading={setLoading}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      <div className="block md:hidden">
        {items?.map((item: any) => (
          <Card className="mt-5">
            <Box
              sx={{
                padding: 2,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Typography gutterBottom variant="h4">
                {item?.name}
              </Typography>

              <FloatingMenu
                visible={menuVisible === item?.id}
                onClose={() => {
                  setMenuVisible(-1)
                }}
                options={onFilterCompund(
                  {
                    onEdit: () => {
                      setUrlSelectedItem(item.image)
                      setModal(true)
                      setEdit(item)
                    },
                    // onAssembly: () => {
                    //   setVisibleAssembly(true)
                    //   // setVisibleCompound(true)
                    //   setEdit(item)
                    // },
                    onDelete: () => {
                      setItemToDelete(item)
                      setVisibleDelete(true)
                    },
                    // onAssociated: async () => {
                    //   let response = await axios.get(
                    //     `${server}/inventory/code?item=${id}`
                    //   )
                    //   setArrayOfCodes(response.data)
                    //   setVisibleCode(true)
                    //   setEdit(item)
                    // },
                    // onTracking: () => {
                    //   setMonitorModal(true)
                    //   setEdit(item)
                    // },
                    // onCompound: async () => {
                    //   let response = await axios.get(
                    //     `${server}/inventory/composition?id=${id}`
                    //   )
                    //   setCompositions(response.data.items || [])
                    //   setVisibleCompound(true)
                    //   setEdit(item)
                    // },
                    addRawMaterial: async () => {
                      let resp = await axios.get(
                        `${server}/inventory/composition?id=${item?.id}`
                      )
                      setRawMaterials(resp?.data?.items || [])
                      setVisibleCompound(true)
                      setEdit(item)
                    },
                    // onPrice: () => {
                    //   setVisiblePrice(true)
                    //   setEdit(record)
                    // },
                    // onCost: () => {
                    //   setVisiblePrice(true)
                    //   setEdit(record)
                    // },
                    // onSendToCatalog: async () => {
                    //   try {
                    //     await setCatalogStatus(record.id, true)
                    //     addAlert({
                    //       message: 'Artículo transferido a catálogo',
                    //       status: 'success',
                    //     })
                    //   } catch (err) {
                    //     addAlert({ message: 'Error de servidor', status: 'error' })
                    //   }
                    // },
                  },
                  item
                )}
              >
                <HiDotsVertical
                  className="cursor-pointer dark:text-white text-primaryGray-400"
                  onClick={() => {
                    setMenuVisible(item?.id)
                    // setEdit(record)
                    // setModal(true)
                  }}
                />
              </FloatingMenu>
            </Box>

            <CardMedia
              component="img"
              image={item?.image || defaultImage}
              alt={`${item?.id}-img`}
              sx={{ maxHeight: 400, width: '100%', objectFit: 'contain' }}
            />

            <CardContent>
              <Typography gutterBottom variant="h6">
                <strong>Categoria:</strong> {item?.category?.name}
              </Typography>

              <Typography gutterBottom variant="h6">
                <strong>Marca:</strong> {item?.brand}
              </Typography>

              {/* <Typography
              gutterBottom
              variant="h6"
            >
              Marca: {item?.brand}
            </Typography> */}

              <Typography gutterBottom variant="h6">
                <strong>SKU:</strong> {item?.sku}
              </Typography>

              <Typography gutterBottom variant="h6">
                <strong>Tipo de Iva:</strong>{' '}
                {objTransform[(item as any)?.ivaType]}
              </Typography>

              <Typography gutterBottom variant="h6">
                <strong>Precio:</strong>{' '}
                {`${getDenomination((item as any)?.currency?.id)} ${formatPipe(
                  (item as any)?.price
                )}`}
              </Typography>

              <Typography gutterBottom variant="h6">
                <strong>Existencia:</strong> {(item as any)?.totalQuantity}
              </Typography>

              <Typography
                gutterBottom
                variant="h6"
                className={`${getItemType(item.type).style}`}
              >
                Tipo: {getItemType(item.type).value}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </div>

      <Modal
        display={modal}
        onAccept={() => null}
        onClose={() => {
          setModal(false)
          setEdit(null)
        }}
        xlClasses='w-[1000px]'
      >
        <InventoryForm
          id={edit ? `edit-${edit?.id}` : 'create'}
          useType={edit ? 'edit' : 'create'}
          defaultValues={edit}
          categoriesValues={categoriesValues}
          submitting={loading}
          onSubmit={onSubmit}
          categories={categories}
          onClose={() => {
            setModal(false)
            setEdit(null)
          }}
          units={units?.map((unit) => {
            // console.log('unittt', unit)
            return { value: unit.id, text: unit.name }
          })}
        />
      </Modal>

      {/* <ModalInventorySearch
        onSubmitInventory={onInventorySubmitFilter}
        modalSearch={false}
        onCloseModalSearch={() => setModalSearch(false)}
      /> */}

      {/* <Modal
        display={modalSearch}
        modalClasses="w-2/5 py-4 px-8"
        onAccept={() => null}
        onClose={() => {
          setModalSearch(false)
        }}
      >
        <div>
          <Form
            form={searchForm}
            classes={`gap-x-6 gap-y-2`}
            onSubmit={(values) => onInventorySubmitFilter(values)}
          >
            <h2 className="col-span-12 text-primary-900 font-bold dark:text-white mb-3">
              Buscar Articulos
            </h2>

            <FormItem name="code" defaultValue={docs[0]} classes="col-span-4">
              <Select
                options={docs}
                setSelectedHelper={(values) => setTypeSelected(values.value)}
                label="Tipo"
              />
            </FormItem>

            {typeSelected === 'keywords' && (
              <FormItem name="name" classes="col-span-8">
                <InputText small label="Palabras clave" maxLength={80} />
              </FormItem>
            )}

            {typeSelected === 'code' && (
              <FormItem name="code" classes="col-span-8">
                <InputText small label="Codigo" maxLength={80} />
              </FormItem>
            )}

            {typeSelected === 'category' && (
              <>
                <FormItem
                  name="category"
                  defaultValue={categoriesValues[0]}
                  classes="col-span-4"
                >
                  <SelectOfCategories
                    options={categoriesValues}
                    setSelectedHelper={(values) => {
                      setSubCategories([
                        { text: 'Todos', value: '0' },
                        ...(categories
                          .find((category) => category?.id === values.value)
                          ?.children.map((sub) => ({
                            text: sub.name,
                            value: sub.id,
                          })) as any[]),
                      ])
                    }}
                    label="Categorias"
                  />
                </FormItem>

                <FormItem
                  name="subCategory"
                  defaultValue={subCategories[0]}
                  classes="col-span-4"
                >
                  <SelectOfCategories
                    options={subCategories}
                    setSelectedHelper={(values) =>
                      console.log('values', values)
                    }
                    label="Sub Categorias"
                  />
                </FormItem>
              </>
            )}

            <div className="col-start-4 col-span-9 flex space-x-2 mt-4 px-1 mt-3">
              <Button
                type="outline"
                classes="w-1/2 mr-4"
                onClick={() => setModalSearch(false)}
                htmlType="button"
              >
                Cancelar
              </Button>

              <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
                Guardar
              </Button>
            </div>
          </Form>
        </div>
      </Modal> */}

      {edit && (
        <Modal
          display={monitorModal}
          // modalClasses="w-2/5 py-4 px-12"
          onAccept={() => null}
          onClose={() => {
            setMonitorModal(false)
            setEdit(null)
          }}
        >
          <RotationForm
            id_item={edit?.id}
            // batchProp={edit?.batch[0]}
            onClose={() => setMonitorModal(false)}
            setNewRotation={setNewRotation}
          ></RotationForm>
        </Modal>
      )}
      <ModalConfirm
        onCancel={() => {
          setVisibleDelete(false)
          setEdit(null)
        }}
        onConfirm={() => {
          onDeleteItem()
        }}
        displayConfirmModal={visibleDelete}
        title="¿Deseas eliminar este producto?"
        body="Al eliminar este producto se borrará dicho artículo del inventario"
      />

      {edit && (
        <Modal
          display={visibleCode}
          onClose={() => {
            setVisibleCode(false)
            setEdit(null)
          }}
          onAccept={() => null}
          xlClasses="xl:w-1/3"
          // modalClasses="w-2/6 py-4 px-12"
        >
          <AssociatedCode
            // items={items}
            // edit={edit}
            associatedCodes={arrayOfCodes}
            refDivScrollAssociated={refDivScrollAssociated}
            setValueToDelete={setValueToDelete}
            setConfirmModalAssociated={setConfirmModalAssociated}
            cbRequest={(newCode) =>
              setArrayOfCodes(
                (prevState) =>
                  prevState && {
                    ...prevState,
                    codes: [...prevState.codes, newCode],
                  }
              )
            }
          />
          {/* <h1 className="font-bold text-primary-900 dark:text-gray-400 mb-8 col-span-12">
          Codigos Asociados
        </h1>
        <div className="max-h-80 overflow-y-auto" ref={refDivScrollAssociated}>
          {items[items?.findIndex((item) => item?.id === edit?.id)]
            ?.associatedCode?.length === 0 && (
            <Empty
              animationProps={{
                height: 200,
                width: 200,
                animation: Code,
              }}
              lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
            >
              <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
                Agregar items en un producto compuesto.
              </p>
            </Empty>
          )}

          {items[
            items?.findIndex((item) => item?.id === edit?.id)
          ]?.associatedCode?.map((value, index) => (
            <div
              className="bg-gray-100 dark:bg-gray-800 rounded-lg mt-4 p-2 flex justify-between items-center"
              key={index}
            >
              <div>
                <h1 className="text-lg ml-3">{value.code}</h1>
              </div>
              <div className="flex">
                <Button
                  classes="border-none"
                  onClick={() => {
                    setValueToDelete(value.id)
                    setConfirmModalAssociated(true)
                  }}
                >
                  <FiTrash2 size={20} color="red" />
                </Button>
              </div>
            </div>
          ))}
        </div>
        <InventoryCodeForm
          onPropSubmitCode={
            async (value) => {
              try {
                const response = await createAssociated({
                  code: value,
                  item: { id: edit.id },
                })
                console.log(response)
              } catch (e: any) {
                addAlert({
                  message: e.response.data.message,
                  status: 'error',
                })
              } finally {
                if (refDivScrollAssociated) {
                  refDivScrollAssociated.current?.scrollTo(0, 0)
                }
              }
            }
            // setArrayOfAssociates((prevValue) => [
            //   ...prevValue,
            //   { id: 0, code: value },
            // ])
          }
        /> */}
        </Modal>
      )}

      {edit && (
        <ModalConfirm
          title="¿Deseas eliminar este código asociado?"
          displayConfirmModal={confirmModalAssociated}
          onCancel={() => {
            setConfirmModalAssociated(false)
          }}
          onConfirm={async () => {
            await deleteAssociatedCode(valueToDelete, edit.id)
            setConfirmModalAssociated(false)
            setArrayOfCodes(
              (prevState) =>
                prevState && {
                  ...prevState,
                  codes: prevState.codes.filter(
                    (code) => code.id !== valueToDelete
                  ),
                }
            )
            // fetchAndSetItems()
          }}
        />
      )}

      <Modal
        display={visibleCompound}
        onClose={() => {
          setVisibleCompound(false)
          setEdit(null)
        }}
        xlClasses="xl:w-5/12"
        // modalClasses="w-5/12 py-4 px-12"
      >
        <>
          <h1 className="text-base mb-2" style={{ fontSize: 20 }}>
            Materias primas
          </h1>
          <label className="text-xs dark:text-primaryGray-700 text-primaryGray-1100">
            {edit?.name}
          </label>

          {rawMaterials?.length === 0 && (
            <Empty
              animationProps={{
                height: 200,
                width: 200,
                animation: EmptyBox,
              }}
              lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
            >
              <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
                Agregar artículos a un producto finalizado.
              </p>
            </Empty>
          )}

          <div className="max-h-80 overflow-y-auto" ref={refDivScrollCompound}>
            {rawMaterials.map((compound: any, index) => (
              <div
                className="my-4 p-2 flex justify-between items-center"
                key={index}
              >
                <div className="truncate">
                  <h2 className="text-sm ml-3">{compound?.name}</h2>
                  <h2 className="text-xs ml-3 text-primaryGray-900">
                    {compound?.unit
                      ? formatAmount(compound?.amount, compound?.unit)
                      : compound.amount}
                  </h2>
                </div>
                <div className="flex">
                  <Button
                    classes="border-none"
                    onClick={() => {
                      setSelectedCompoundToEdit(compound)
                      setVisibleCompositionEdit(true)
                    }}
                  >
                    <IoMdCreate size={20} className="text-primary-700" />
                  </Button>

                  <Button
                    classes="border-none"
                    onClick={async () => {
                      if (compound.idItem) {
                        setRawMaterials((prevState) =>
                          prevState.filter((v) => v.idItem !== compound.idItem)
                        )
                      } else {
                        setConfirmModalCompound(true)
                        setValueCompoundToDelete(compound?.id_composition)
                      }
                    }}
                  >
                    <FiTrash2 size={20} className="text-danger-100" />
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8"></div>
          {edit && (
            <Form
              form={compoundForm}
              onSubmit={async () => {
                try {
                  await createComposition({
                    compound_item: edit.id,
                    items: rawMaterials.reduce((a, b) => {
                      if (b.idItem) {
                        return [...a, { id: b.idItem, amount: b.amount }]
                      }
                      return a
                    }, []),
                  })
                  if (edit) {
                    let response = await axios.get(
                      `${server}/inventory/composition?id=${edit.id}`
                    )
                    setRawMaterials(response.data.items || [])
                  }
                  addAlert({
                    message: 'Materia prima añadida satisfactoriamente',
                    status: 'success',
                  })
                  setVisibleCompound(false)
                  // await fetchAndSetItems()
                  if (refDivScrollCompound) {
                    refDivScrollCompound.current?.scrollTo(0, 0)
                  }
                } catch (e: any) {
                  addAlert({
                    message: 'Error al asignar compuestos',
                    status: 'error',
                  })
                }
              }}
              classes={`gap-x-6 gap-y-2`}
            >
              {/* <FieldArraySelect
          name="items"
          classes="xl:col-start-2 col-start-1 col-span-11"
          list={arrayOfCompunds}
        /> */}

              {/* Prototipo para prueba. */}
              <FieldArrayAutocomplete
                url="inventory/item/simple-search"
                bodyGet="items"
                queryParam="param"
                // valuesToCompare={items}
                edit={edit}
                valuesToCompare={rawMaterials}
                useCase="RAW_MATERIAL"
                onChangeValue={async ({ value, amount }) => {
                  setRawMaterials((prevState) => [
                    ...prevState,
                    { name: value.name, amount, idItem: value.id },
                  ])
                  // setCompositions((prevState) => [
                  //   ...prevState,
                  //   { name: value.name, amount, idItem: value.id },
                  // ])

                  // try {
                  //   await createComposition({
                  //     compound_item: value.id,
                  //     item: {
                  //       id: edit.id,
                  //     },
                  //     amount,
                  //   })
                  //   await fetchAndSetItems()
                  //   if (refDivScrollCompound) {
                  //     refDivScrollCompound.current?.scrollTo(0, 0)
                  //   }
                  // } catch (e: any) {
                  //   addAlert({
                  //     message: e.response.data.message,
                  //     status: 'error',
                  //   })
                  // }
                }}
              />

              <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-10 block">
                <Button
                  type="outline"
                  classes="w-6/12 mr-4"
                  onClick={() => {
                    setVisibleCompound(false)
                    setEdit(null)
                  }}
                  htmlType="button"
                >
                  Cancelar
                </Button>
                <Button type="primary" classes="w-6/12 mr-4" htmlType="submit">
                  Guardar
                </Button>
              </div>
            </Form>
          )}
        </>
      </Modal>

      <Modal
        display={visibleAssembly}
        onClose={() => {
          setVisibleAssembly(false)
          setEdit(null)
        }}
      >
        <h1>Ensamblado</h1>
        {items[items.findIndex((item) => item?.id === edit?.id)]?.assembly
          ?.length === 0 && (
          <Empty
            animationProps={{
              height: 200,
              width: 200,
              animation: EmptyBox,
            }}
            lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
          >
            <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
              Agregar items en un producto ensamblado.
            </p>
          </Empty>
        )}

        <div className="max-h-80 overflow-y-auto" ref={refDivScrollCompound}>
          {items[
            items.findIndex((item) => item?.id === edit?.id)
          ]?.assembly?.map((assembly: any, index) => (
            <div
              className="bg-gray-100 dark:bg-gray-800 rounded-lg my-4 p-2 flex justify-between items-center"
              key={index}
            >
              <div className="truncate">
                <h1 className="text-sm ml-3">
                  {assembly?.productionItem?.name}
                </h1>
                <h1 className="text-xs ml-3">
                  {formatAmount(
                    assembly?.productionItem.requiredQuantity,
                    assembly?.productionItem?.unit
                  )}
                </h1>
              </div>
              <div className="flex">
                <Button
                  classes="border-none"
                  onClick={async () => {
                    // setSelectedCompoundToEdit(assembly)
                    // setVisibleCompositionEdit(true)

                    // setSelectedCompoundToEdit(assembly)

                    setSelectedAssemblyToEdit(assembly)
                    // setVisibleAssembly(true)
                    setVisibleAssemblyEdit(true)
                  }}
                >
                  <IoMdCreate size={20} className="text-primary-700" />
                </Button>

                <Button
                  classes="border-none"
                  onClick={() => {
                    // setConfirmModalCompound(true)
                    setConfirmModalAssembly(true)
                    // setValueCompoundToDelete(assembly.id)
                    setValueAssemblyToDelete(assembly.id)
                  }}
                >
                  <FiTrash2 size={20} color="red" />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8"></div>
        {edit && (
          <Form
            form={compoundForm}
            onSubmit={() => null}
            classes={`gap-x-6 gap-y-2`}
          >
            {/* <FieldArraySelect
          name="items"
          classes="xl:col-start-2 col-start-1 col-span-11"
          list={arrayOfCompunds}
        /> */}

            {/* Prototipo para prueba. */}
            <FieldArrayAutocomplete
              url="inventory/item/production"
              bodyGet="productionItems"
              queryParam="searchCustom"
              // valuesToCompare={items}
              edit={edit}
              valuesToCompare={
                items[items.findIndex((item) => item?.id === edit?.id)]
                  ?.assembly
              }
              useCase="ASSEMBLY"
              onChangeValue={async ({
                value,
                amount,
              }: {
                value: {
                  id: string
                  unit: IUnit
                }
                amount: number
              }) => {
                try {
                  await createAssembly({
                    assemblyItem: {
                      id: edit.id,
                    },
                    productionItem: {
                      id: value.id,
                    },
                    amount,
                  })
                  await fetchAndSetItems([], 0, fastSearch)
                  if (refDivScrollCompound) {
                    refDivScrollCompound.current?.scrollTo(0, 0)
                  }
                } catch (e: any) {
                  addAlert({
                    message: e.response.data.message,
                    status: 'error',
                  })
                }
              }}
            />
          </Form>
        )}
      </Modal>

      {valueCompoundToDelete && (
        <ModalConfirm
          title="¿Deseas eliminar este compuesto?"
          displayConfirmModal={confirmModalCompound}
          onCancel={() => setConfirmModalCompound(false)}
          onConfirm={async () => {
            try {
              await removeComposition(valueCompoundToDelete)
              setRawMaterials((prevState) =>
                prevState.filter(
                  (v) => v.id_composition !== valueCompoundToDelete
                )
              )
              addAlert({
                message: 'Compuesto eliminado satisfactoriamente',
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: 'Error al eliminar compuesto',
                status: 'error',
              })
            }
            // await fetchAndSetItems()
            setConfirmModalCompound(false)
          }}
        />
      )}

      <ModalConfirm
        title="¿Deseas eliminar este producto de producción?"
        displayConfirmModal={confirmModalAssembly}
        onCancel={() => setConfirmModalAssembly(false)}
        onConfirm={async () => {
          await removeAssembly(valueAssemblyToDelete)
          // await fetchAndSetItems()
          // await removeCompound(valueCompoundToDelete, edit.id)
          setConfirmModalAssembly(false)
        }}
      />

      {edit && (
        <Modal
          display={visiblePrice}
          scroll="scroll"
          onClose={() => {
            setVisiblePrice(false)
            setEdit(null)
          }}
          // modalClasses="w-3/6 py-4 px-12 min-w-min"
        >
          <CostForm
            cost={edit?.cost?.length > 0 ? edit?.cost[0]?.amount : '0.00'}
            price={edit?.price?.length > 0 ? edit?.price[0]?.amount : '0.00'}
            excent={edit?.exempt}
            id_selected={edit?.id}
            items={
              edit?.type === 'COMPOUND'
                ? edit?.composition
                : edit?.type === 'ASSEMBLY'
                ? edit?.assembly
                : []
            }
            name={edit?.name && edit.name}
            itemType={edit?.type}
            onClose={() => {
              setVisiblePrice(false)
              setEdit(null)
            }}
            getItems={fetchAndSetItems}
            submitText="Guardar"
          ></CostForm>
        </Modal>
      )}

      <Modal
        display={visibleCompositionEdit}
        onClose={() => {
          setVisibleCompositionEdit(false)
          // setEdit(null)
        }}
        xlClasses="xl:w-1/3"
        // modalClasses="w-2/6 py-4 px-12"
      >
        <h1 className="mb-4 text-lg">Editar composición</h1>
        <label className="text-xs dark:text-primaryGray-700 text-primaryGray-dark">
          {selectedCompoundToEdit?.item?.name}
        </label>
        <EditCompoundForm
          defaultValues={selectedCompoundToEdit}
          onCancel={() => setVisibleCompositionEdit(false)}
          onSubmitForm={async (values) => {
            if (selectedCompoundToEdit.idItem) {
              let newArray = rawMaterials.map((v) => {
                if (v.idItem === selectedCompoundToEdit.idItem) {
                  return {
                    ...v,
                    amount: values.amount,
                  }
                }
                return v
              })
              setRawMaterials(newArray)
            } else {
              try {
                await axios.patch(`${server}/inventory/composition`, {
                  id: selectedCompoundToEdit.id_composition,
                  amount: values.amount,
                })
                let newArray = rawMaterials.map((v) => {
                  if (
                    v.id_composition === selectedCompoundToEdit.id_composition
                  ) {
                    return {
                      ...v,
                      amount: values.amount,
                    }
                  }
                  return v
                })
                setRawMaterials(newArray)
                addAlert({
                  message: 'Materia prima modificado satisfactoriamente',
                  status: 'success',
                })
              } catch (err) {
                addAlert({
                  message: 'Error al modificar materia prima',
                  status: 'error',
                })
              }
            }
            setVisibleCompositionEdit(false)
          }}
        />
      </Modal>

      <Modal
        display={visibleAssemblyEdit}
        onClose={() => setVisibleAssemblyEdit(false)}
        //</>modalClasses="w-2/6 py-4 px-12"
      >
        <h1 className="mb-4">Editar Ensamblado</h1>
        <EditCompoundForm
          isAssembly={true}
          defaultValues={selectedAssemblyToEdit}
          onCancel={() => setVisibleAssemblyEdit(false)}
          onSubmitForm={async (values) => {
            await updateAssembly({
              id: selectedAssemblyToEdit.id,
              amount: values.productionItem.requiredQuantity,
            })
            await fetchAndSetItems([], 0)
            setVisibleAssemblyEdit(false)
          }}
        />
      </Modal>

      <ModalViewWithTabs
        display={modalFromRow}
        onClose={() => {
          setModalFromRow(false)
          setDataWithTabs([])
        }}
        dataWithTabs={dataWithTabs}
      />

      <FloatingForm
        visible={visibleAdjust}
        onClose={() => setVisibleAdjust(false)}
        topClass="top-16"
        rightClass="right-10"
      >
        <PriceAdjustForm
          makeAdjustment={(percentage) => adjustPricesGlobally(percentage)}
          onCancel={() => setVisibleAdjust(false)}
        />
      </FloatingForm>

      <FloatingForm
        visible={modalSearch}
        onClose={() => setModalSearch(false)}
        topClass="top-20"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        <AdvancedInventoryForm
          onSubmit={async (values) => {
            let params = Object.keys(values).reduce((a, b) => {
              if (values[b] && values[b] !== 'all') {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)

            fetchAndSetItems(params, 0)

            // setSearchParams(

            // )

            // if (currentPage === 0) {
            //   setLoading(true)
            //   await fetchAndSetItems(
            //     [],
            //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
            //   )
            //   setLoading(false)
            // } else {
            //   setCurrentPage(0)
            // }
          }}
          onCloseAdvancedForm={() => setModalSearch(false)}
        />
        {/* <InventorySearchFormFloating
          onCloseModalSearch={() => setModalSearch(false)}
          onSubmitInventory={onInventorySubmitFilter}
        /> */}
        {/* <h1>nuevo h1</h1> */}
        {/* <PriceAdjustForm
          makeAdjustment={(percentage) => adjustPricesGlobally(percentage)}
          onCancel={() => setVisibleAdjust(false)}
        /> */}
      </FloatingForm>
    </>
  )
}

export default Inventory

interface InventoryProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}
